import Axios from 'axios'
import { ElMessage } from 'element-plus'
import router from '@/router'
const newRequest = Axios.create({
  baseURL: 'https://reg.alljoy.com.cn/',
//  baseURL:'http://localhost:5204/',
  timeout: 100000
})
// 添加请求拦截---每次发送请求，都会经过请求拦截
newRequest.interceptors.request.use(
  function (config) {
    if (sessionStorage.getItem('token')) {
      config.headers.authorToken = sessionStorage.getItem('token')
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)
// 添加响应拦截器
newRequest.interceptors.response.use(
  function (response) {
    // 处理相应数据
    if (response.status === 200) {
      if (response.data.code === 200) {
        return Promise.resolve(response.data)
      } else if (response.data.code === 203) {
        // 登录状态丢失
        ElMessage.error(response.data.msg || '登录状态丢失')
        router.push({
          path: '/index',
          query: { ExhCode: sessionStorage.getItem('ExhCode') }
        })
      } else if (response.data.code === 204) {
        ElMessage.error(response.data.msg || '参数缺失')
      } else if (response.data.code === 500) {
        ElMessage.error(response.data.msg || '程序错误')
      } else {
        ElMessage.error(response.data.msg || '请求错误')
      }
    }
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error)
  }
)
export default newRequest
